import { createTheme } from '@mui/material/styles';

/**
 * MUI v5 flipped the default `variant` for TextField/Select/FormControl from
 * "standard" (underline, matching @material-ui/core v4 -- what every screen
 * in this app was actually designed against) to "outlined" (bordered box).
 * Components that never set an explicit `variant` silently changed
 * appearance across the whole site after the v4->v5 migration. Restoring the
 * old default centrally here fixes every such spot at once instead of
 * patching each component's variant prop individually.
 */
export const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: { variant: 'standard' }
    },
    MuiSelect: {
      defaultProps: { variant: 'standard' }
    },
    MuiFormControl: {
      defaultProps: { variant: 'standard' }
    }
  }
});
